export const STATUS_STYLES = {
  // ── API values (lowercase) ──────────────────────────────
  confirmed:    { background: 'rgba(74,222,128,0.12)',  color: '#4ADE80', dot: '#4ADE80',  label: 'Confirmed'    },
  in_progress:  { background: 'rgba(232,197,71,0.14)',  color: '#E8C547', dot: '#E8C547',  label: 'In Progress'  },
  completed:    { background: 'rgba(96,165,250,0.12)',  color: '#60A5FA', dot: '#60A5FA',  label: 'Completed'    },
  pending:      { background: 'rgba(248,113,113,0.12)', color: '#F87171', dot: '#F87171',  label: 'Pending'      },
  cancelled:    { background: 'rgba(156,163,175,0.12)', color: '#9CA3AF', dot: '#9CA3AF',  label: 'Cancelled'    },

  // ── Legacy display values (capitalized) — kept for safety ──
  Confirmed:    { background: 'rgba(74,222,128,0.12)',  color: '#4ADE80', dot: '#4ADE80',  label: 'Confirmed'    },
  'In Progress':{ background: 'rgba(232,197,71,0.14)',  color: '#E8C547', dot: '#E8C547',  label: 'In Progress'  },
  Completed:    { background: 'rgba(96,165,250,0.12)',  color: '#60A5FA', dot: '#60A5FA',  label: 'Completed'    },
  Pending:      { background: 'rgba(248,113,113,0.12)', color: '#F87171', dot: '#F87171',  label: 'Pending'      },
}
